import { APPOINTMENT_TITLE } from '../utils/common';
import { APPOINTMENT_STATUSES, APPOINTMENT_TYPES } from '../utils/entries';
import { CONTACT_US_INFO_TYPE } from '../utils/entries/contactUsInfoType';
import { appointmentStrategies } from './constants';
// eslint-disable-next-line no-unused-vars
import { AppointmentStrategy } from './strategies/appointment/AppointmentStrategy';

export class AppointmentService {
  static getStrategy(appointment: common.EngineerAppointment, amendedInfo: common.AmendsInfo[]): AppointmentStrategy {
    return appointmentStrategies.find((strategy) => strategy.isApplicable(appointment, amendedInfo))!;
  }

  static getAppointmentButtonText(
    status: string,
    type: string,
    isAmendAppointmentEnabled: boolean,
    isStatusPONR: boolean,
  ): string {
    if (!isAmendAppointmentEnabled || isStatusPONR || type === APPOINTMENT_TYPES.expert) {
      return '';
    }
    switch (status) {
      case APPOINTMENT_STATUSES.Confirmed:
      case APPOINTMENT_STATUSES.SupplierChanged:
      case APPOINTMENT_STATUSES.AtRisk:
      case APPOINTMENT_STATUSES.Rejected:
        return `Change ${APPOINTMENT_TITLE[type]}`;
      case APPOINTMENT_STATUSES.CustomerMissed:
        return '';
      default:
        return '';
    }
  }

  static getAppointmentCardDetails(
    appointment: common.EngineerAppointment,
    amendedInfo: common.AmendsInfo[],
    isAuthenticated: boolean,
    isAmendAppointmentEnabled: boolean,
  ): common.AppointmentCardDetails {
    const strategy = AppointmentService.getStrategy(appointment, amendedInfo);
    return {
      hasAmendAppointmentButton: strategy.isAmendable(appointment, isAuthenticated, isAmendAppointmentEnabled),
      hasReminder: strategy.isReminderAvailable(appointment),
      hasSiteContact: strategy.isSiteContactAvailable(appointment),
      hasHelpSection: strategy.isHelpSectionAvailable(appointment),
      contactUsInfoType: strategy.getInfoType(appointment, isAuthenticated, isAmendAppointmentEnabled),
    };
  }

  static checkPONRStatus = (status: common.AppointmentStatus, contactUsInfoType: common.ContactUsInfo | null) =>
    status === APPOINTMENT_STATUSES.Confirmed && contactUsInfoType === CONTACT_US_INFO_TYPE.ForbidToAmend;

  static showLoginSection = (status: common.AppointmentStatus) =>
    ![APPOINTMENT_STATUSES.Completed, APPOINTMENT_STATUSES.Closed].includes(status);

  static showLoginButton = (status: common.AppointmentStatus, type, isStatusPONR: boolean) => {
    if (type === APPOINTMENT_TYPES.expert) {
      return true;
    }
    if (isStatusPONR) {
      return false;
    }
    return status !== APPOINTMENT_STATUSES.CustomerMissed;
  };
}
